// Español (neutro/internacional) — mirrors the key structure of en.js exactly.
const es = {
  common: {
    backToHome: 'Volver al inicio',
    studentAlt: 'Alumno {{index}}',
  },
  nav: {
    home: 'Inicio',
    courses: 'Cursos',
    pricing: 'Precios',
    about: 'Nosotros',
    contact: 'Contacto',
    faq: 'Preguntas Frecuentes',
    levelTest: 'Prueba de Nivel',
    bookTrial: 'Reservar Clase',
  },
  home: {
    badges: {
      globalExpertise: 'EXPERIENCIA GLOBAL',
      cambridgeCertified: 'CERTIFICACIÓN CAMBRIDGE',
      academicExcellence: 'EXCELENCIA ACADÉMICA',
      nativeSpeakerInsight: 'VISIÓN NATIVA',
      resultsDriven: 'ENFOQUE EN RESULTADOS',
    },
    trust: {
      businessName: 'Inglés para Negocios', businessLine1: 'Inglés para', businessLine2: 'Negocios',
      generalName: 'Inglés General', generalLine1: 'Inglés', generalLine2: 'General',
      speakingName: 'Desarrollo del Habla', speakingLine1: 'Desarrollo', speakingLine2: 'del Habla',
      academicName: 'Escritura Académica', academicLine1: 'Escritura', academicLine2: 'Académica',
      portugueseName: 'Portugués para Extranjeros', portugueseLine1: 'Portugués para', portugueseLine2: 'Extranjeros',
      oneToOneName: 'Clase Individual', oneToOneLine1: 'Clase', oneToOneLine2: 'Individual',
    },
    video: {
      playVideo: 'Reproducir video',
      replayVideo: 'Volver a ver',
      replay: 'Repetir',
      mute: 'Silenciar',
      unmute: 'Activar sonido',
      volume: 'Volumen',
      liveLessons: 'Clases en vivo disponibles ahora',
    },
    heroImageAlt: 'Cida, profesora de inglés, dando la bienvenida a los alumnos',
    carousel: {
      previous: 'Anterior',
      next: 'Siguiente',
      navigation: 'Navegación del carrusel',
      show: 'Mostrar {{title}}',
    },
    community: {
      multiculturalStudents: 'Alumnos multiculturales',
      aviationLesson: 'Clase de inglés para aviación',
      readingStrategiesLesson: 'Clase de estrategias avanzadas de lectura',
      badge: 'Comunidad Global',
      title: 'Únete a Alumnos de [hl]Todo el Mundo[/hl]',
      body: 'Nuestros alumnos vienen de distintos orígenes y culturas, unidos por el objetivo de comunicarse en inglés con confianza. Formarás parte de una comunidad acogedora de alumnos de América Latina, Europa, Asia y más allá.',
      stat: 'Más de 500 alumnos satisfechos en todo el mundo',
    },
    learnMore: 'Saber Más',
    viewAllTestimonials: 'Ver todos los testimonios',
    hero: {
      badge: 'PROFESORES CERTIFICADOS CELTA Y TESOL.',
      brand: 'FRANKLY TALKING',
      title: 'Habla Inglés con Confianza',
      subtitle: 'Clases de inglés personalizadas para comunicación real, oportunidades internacionales y más confianza al hablar.',
      ctaPrimary: 'Evalúa tu Nivel',
      ctaSecondary: 'Reserva una Clase',
    },
    why: {
      badge: 'Por Qué Elegirnos',
      title: 'Aprende Inglés con [hl]Confianza[/hl]',
      body: 'Aprende inglés con confianza, guiado por una profesora altamente calificada y con amplia experiencia internacional. Serás enseñado por una instructora nativa de portugués, con gran experiencia global en la enseñanza del idioma inglés y certificación plena por la Universidad de Cambridge.',
      body2: 'Con una maestría y un doctorado en curso en Metodología de Enseñanza del Idioma Inglés, nuestro enfoque combina excelencia académica con habilidades prácticas de comunicación para que logres fluidez de forma más rápida y eficaz.',
      closing: 'Comienza hoy tu camino hacia la fluidez en inglés.',
      differentLabel: 'Qué nos hace diferentes:',
    },
    howItWorks: {
      badge: 'Primeros Pasos',
      title: 'Cómo Funciona',
      subtitle: 'Un camino simple desde tu primer paso hasta comunicarte con confianza.',
    },
    programsSection: {
      badge: 'Nuestros Cursos',
      title: 'Programas Más Populares',
      subtitle: 'Opciones de aprendizaje flexibles, pensadas para metas y progreso reales.',
      cta: 'Ver Todos los Cursos',
    },
    testimonialsSection: {
      badge: 'Testimonios',
      title: 'Lo Que Dicen Nuestros Alumnos',
      subtitle: 'Historias reales de nuestra comunidad global de alumnos.',
    },
    ctaSection: {
      title: '¿Listo Para Comenzar Tu [hl]Camino en el Inglés[/hl]?',
      body: 'Haz tu evaluación de nivel gratuita o reserva una clase de prueba y descubre el camino de aprendizaje ideal para tus objetivos.',
      primary: 'Evalúa tu Nivel',
      secondary: 'Reserva una Clase',
    },
    featuresList: [
      { title: 'Experiencia Internacional en la Enseñanza', description: 'Experiencia enseñando a alumnos de distintos países, culturas y contextos de aprendizaje.' },
      { title: 'Especialización Certificada por Cambridge', description: 'Certificación Cambridge con formación académica avanzada en Enseñanza del Idioma Inglés.' },
      { title: 'Maestría y Especialización de Nivel Doctoral', description: 'Excelencia académica que combina una maestría con investigación doctoral en curso en Metodología de Enseñanza del Idioma Inglés.' },
      { title: 'Explicaciones Claras para Hablantes de Portugués', description: 'Una profesora nativa de portugués que entiende tus dificultades y explica el inglés con claridad.' },
      { title: 'Desarrollo de la Expresión Oral', description: 'Clases prácticas diseñadas para generar confianza en conversaciones reales.' },
    ],
    stepsList: [
      { title: 'Evalúa tu Nivel', description: 'Descubre tu nivel actual con una evaluación rápida y práctica.' },
      { title: 'Recibe tu Plan Recomendado', description: 'Te sugerimos el paquete que mejor se adapta a tu nivel y tus objetivos.' },
      { title: 'Reserva y Empieza a Aprender', description: 'Elige tu paquete, programa tus clases y empieza a aprender con confianza.' },
    ],
    programsList: [
      { title: 'Inglés General', subtitle: 'De Principiante a Avanzado', description: 'Gana confianza para hablar, escuchar, leer, escribir y dominar la gramática y la pronunciación.' },
      { title: 'Inglés para Negocios', subtitle: 'Comunicación Profesional', description: 'Comunícate con más profesionalismo y confianza en reuniones, correos, presentaciones y entrevistas.' },
      { title: 'Inglés Académico', subtitle: 'Inglés con Fines Académicos', description: 'Prepárate para ensayos, clases, presentaciones, toma de notas y éxito académico.' },
    ],
  },
  courses: {
    personalizedFor: 'Personalizado para',
    yourGoals: 'Tus Objetivos',
    availableNow: 'Disponible Ahora',
    hero: {
      badge: 'Nuestros Programas',
      title: 'Cursos Diseñados en Torno a [hl]Metas Reales[/hl]',
      body: 'Ya sea para mejorar tu inglés en el trabajo, los estudios, los viajes o tu crecimiento personal, nuestros cursos están personalizados para ayudarte a avanzar con confianza.',
    },
    ctaSection: {
      title: '¿No sabes qué curso es el ideal para ti?',
      body: 'Haz la evaluación de nivel gratuita o reserva una clase de prueba y déjanos ayudarte a elegir el mejor camino.',
      primary: 'Evalúa tu Nivel',
      secondary: 'Reserva una Clase',
    },
    coursesList: [
      {
        title: 'Inglés General para la Vida Real',
        subtitle: 'De Principiante a Avanzado',
        description: 'Habla inglés con confianza donde sea que la vida te lleve. Nuestras clases de Inglés General te preparan para viajes, programas de intercambio, turismo, oportunidades laborales y para construir relaciones en contextos internacionales y multiculturales. Menos teoría, más comunicación real. Aprende el inglés que realmente necesitas para vivir, conectar y tener éxito a nivel internacional.',
        features: ['Maneja aeropuertos, hoteles y situaciones de viaje con facilidad', 'Comunícate profesionalmente en el trabajo y en entrevistas', 'Conéctate de forma natural en redes sociales y entornos globales', 'Construye relaciones significativas con personas de diferentes culturas', 'Haz amigos y desenvuélvete en conversaciones reales en el extranjero'],
        button: 'Reservar Clase de Prueba',
      },
      {
        title: 'Inglés para Negocios',
        subtitle: 'Comunicación Profesional',
        description: 'Desarrolla las habilidades de idioma y comunicación que necesitas para reuniones, presentaciones, entrevistas, correos electrónicos, negociaciones e interacciones en el entorno laboral internacional.',
        features: ['Redacción de correos', 'Presentaciones', 'Negociaciones', 'Preparación para entrevistas'],
        button: 'Reservar Clase de Prueba',
      },
      {
        title: 'Inglés con Fines Académicos',
        subtitle: 'Éxito Académico',
        description: 'Prepárate para el éxito académico con clases centradas en ensayos, clases magistrales, toma de notas, lectura académica, presentaciones y comunicación eficaz en los estudios en inglés.',
        features: ['Redacción de ensayos', 'Toma de notas', 'Habilidades de investigación', 'Vocabulario académico'],
        button: 'Reservar Clase de Prueba',
      },
      {
        title: 'Clases de Conversación',
        subtitle: 'Fluidez y Confianza',
        description: 'Practica el habla real con confianza a través de clases dinámicas basadas en debates, enfocadas en fluidez, pronunciación, espontaneidad y comunicación natural.',
        features: ['Temas de debate', 'Pronunciación', 'Fluidez natural', 'Desarrollo de la confianza'],
        button: 'Reservar Clase de Prueba',
      },
      {
        title: 'Portugués de Brasil',
        subtitle: 'Para Hablantes Nativos de Inglés',
        description: 'Aprende portugués de Brasil de forma natural, personalizada y que genera confianza, con una profesora nativa que te ayuda a hablar con claridad y comodidad.',
        features: ['Profesora nativa', 'Contexto cultural', 'Frases prácticas', 'Ritmo personalizado'],
        button: 'Reservar Clase de Prueba',
      },
    ],
  },
  pricing: {
    mostPopular: 'MÁS POPULAR',
    startingAt: 'Desde',
    getStarted: 'Empezar Ahora',
    groupOption: 'Opción grupal',
    groupOptionCaption: 'Impulso compartido con una rutina semanal estructurada.',
    privateOption: 'Opción individual',
    privateOptionCaption: 'Máxima personalización para un progreso acelerado.',
    focusLabel: 'Enfoque',
    focusValue: 'Desarrollo rápido del habla',
    rhythmLabel: 'Ritmo',
    rhythmValue: 'Práctica semanal constante',
    idealForLabel: 'Ideal para',
    idealForValue: 'Alumnos con objetivos urgentes',
    intensiveMainImageAlt: 'Alumno en una clase intensiva de inglés en línea',
    intensiveSecondaryImageAlt: 'Profesora guiando una clase de inglés en vivo',
    recommendedWhen: 'Recomendado cuando',
    recommendedWhenTitle: 'Necesitas resultados en menos tiempo',
    recommendedWhenBody: 'Ideal para mudanzas, objetivos profesionales, entrevistas, viajes o preparación académica.',
    specialOffersBadge: 'Ofertas Especiales',
    specialOffersTitle: 'Bonos y Promociones',
    specialOffersSubtitle: 'Valor adicional para alumnos comprometidos.',
    planLabels: {
      private: 'Atención personalizada',
      pair: 'Aprendizaje compartido',
      trio: 'Formato en equipo reducido',
      group: 'Mejor relación calidad-precio',
    },
    hero: {
      badge: 'Precios',
      title: 'Elige Tu [hl]Plan[/hl]',
      body: 'Ya sea que prefieras atención personalizada o aprender con otros, tenemos la opción perfecta para ti.',
    },
    ctaSection: {
      title: '¿No sabes qué paquete es el ideal para ti?',
      body: 'Haz la evaluación de nivel gratuita y recibe un plan recomendado según tu nivel y tus objetivos.',
      primary: 'Evalúa tu Nivel',
      secondary: 'Reserva una Clase',
    },
    intensivePlan: {
      badge: '¿Quieres Resultados Más Rápidos?',
      title: 'Plan Mensual Intensivo',
      subtitle: '3 clases por semana',
      body: 'Perfecto para alumnos que quieren progreso real en menos tiempo.',
      groupPriceTemplate: 'Desde {{amount}}/mes (grupo)',
      privatePriceTemplate: 'Desde {{amount}}/mes (particular)',
    },
    whyStudentsBadge: 'Por Qué los Alumnos Nos Eligen',
    whyStudentsList: [
      { text: 'Inglés práctico para situaciones reales en el extranjero' },
      { text: 'Grupos pequeños significan más tiempo para hablar' },
      { text: 'Horarios flexibles, adaptados a tu rutina' },
      { text: 'Enseñanza premium con calificaciones internacionales' },
    ],
    priceTemplate: '1 hora: {{amount}}',
    priceTemplatePerStudent: '1 hora: {{amount}} por alumno',
    lessonsTemplate: 'Paquete de 10 clases: {{amount}} (ahorras {{save}})',
    durationTemplate: 'Intensivo (1,5h): {{amount}}',
    packagesList: [
      { name: 'Clases Particulares (1:1)', description: 'Para progreso rápido y máxima personalización', features: ['Atención totalmente personalizada', 'Horario flexible', 'Google Meet incluido', 'Seguimiento del progreso', 'Material personalizado'] },
      { name: 'Clases en Pareja (2 alumnos)', description: 'Aprende con un amigo y mantén la motivación', features: ['Aprende con un amigo', 'Menor costo por alumno', 'Google Meet incluido', 'Más tiempo para hablar', 'Aprendizaje colaborativo'] },
      { name: 'Clases en Trío (3 alumnos)', description: 'Dinámicas, interactivas y accesibles', features: ['Dinámica de grupo pequeño', 'Más interacción', 'Google Meet incluido', 'Aprendizaje entre compañeros', 'Buena relación calidad-precio'] },
      { name: 'Grupo Pequeño (4–6 alumnos)', description: 'Mejor relación calidad-precio y práctica real de conversación', features: ['Mejor opción de valor', 'Práctica real de conversación', 'Google Meet incluido', 'Ambiente de comunidad', 'Horario constante'] },
    ],
    offersList: [
      { title: 'Oferta Especial', description: '20% de descuento para alumnos de trío y grupo pequeño que compren paquetes intensivos de 10 clases.' },
      { title: 'Bono por Recomendación', description: 'Recomienda a un amigo y recibe un 10% de descuento en la renovación de tu próximo paquete después de que se inscriba.' },
    ],
  },
  about: {
    whatMakesUsDifferentBadge: 'Nuestro Enfoque',
    whatMakesUsDifferentTitle: 'Qué Nos Hace Diferentes',
    whatMakesUsDifferentSubtitle: 'Nuestro enfoque combina experiencia con personalización.',
    coreValuesBadge: 'Principios Rectores',
    coreValuesTitle: 'Nuestros Valores',
    coreValuesSubtitle: 'Los principios que guían todo lo que hacemos.',
    heroImageAlt: 'Clase de pronunciación en inglés',
    methodImageAlt: 'Alumnos practicando conversación e interacción',
    hero: {
      badge: 'Sobre Nosotros',
      title: 'Nuestra Historia',
      body1: 'Frankly Talking English nació de una pasión por la enseñanza y un compromiso con la comunicación real. Con años de experiencia, metodología certificada y un enfoque personalizado, ayudamos a los alumnos a hablar con más claridad, confianza y naturalidad.',
      body2: 'Creemos que todo alumno merece una educación en inglés de alta calidad, atractiva y práctica. Nuestra misión es derribar las barreras del idioma y ayudar a las personas a conectarse con el mundo a través de una comunicación segura.',
      stat: 'Más de 500 alumnos de más de 30 países',
    },
    methodology: {
      badge: 'Nuestro Enfoque',
      title: 'Nuestra Metodología de Enseñanza',
      body: 'Nuestras clases están diseñadas para equilibrar estructura, comunicación y personalización. Creemos que los alumnos aprenden mejor cuando las clases son prácticas, atractivas y conectadas con la vida real.',
    },
    ctaSection: {
      title: '¿Listo para aprender con [hl]confianza[/hl]?',
      body: 'Comienza tu camino con una clase de prueba o descubre tu nivel con nuestra evaluación gratuita.',
      primary: 'Reservar Clase de Prueba',
      secondary: 'Evaluar tu Nivel',
    },
    differentiatorsList: [
      { text: 'Rutas de aprendizaje personalizadas' },
      { text: 'Enfoque en la comunicación real' },
      { text: 'Enseñanza certificada y con experiencia' },
      { text: 'Experiencia de aprendizaje flexible' },
      { text: 'Seguimiento claro del progreso' },
      { text: 'Ambiente cálido que genera confianza' },
    ],
    valuesList: [
      { title: 'Autenticidad', description: 'Conexiones genuinas y comentarios honestos' },
      { title: 'Empatía', description: 'Comprensión de tu camino único de aprendizaje' },
      { title: 'Confianza', description: 'Desarrollando tu capacidad de comunicarte con libertad' },
      { title: 'Excelencia', description: 'Altos estándares en todo lo que hacemos' },
      { title: 'Crecimiento', description: 'Mejora continua y progreso constante' },
      { title: 'Comunicación', description: 'Intercambio claro, eficaz y significativo' },
    ],
    methodPointsList: [
      { text: 'Enfoque comunicativo centrado en el uso real' },
      { text: 'Clases estructuradas con objetivos de aprendizaje claros' },
      { text: 'Retroalimentación regular y seguimiento del progreso' },
      { text: 'Contenido adaptado a tus intereses y objetivos' },
    ],
  },
  header: {
    toggleMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    login: 'Acceder',
    signOut: 'Cerrar sesión',
    adminPortal: 'Portal del Administrador',
    studentPortal: 'Portal del Alumno',
    myPortal: 'Mi Portal',
    selectLanguage: 'Seleccionar idioma',
  },
  footer: {
    quickLinks: 'Enlaces Rápidos',
    support: 'Soporte',
    contact: 'Contacto',
    locationDefault: 'ONLINE EN TODO EL MUNDO - Clases presenciales disponibles a pedido',
    descriptionDefault: 'Clases online personalizadas, pensadas para que te comuniques con claridad, naturalidad y confianza.',
    studentAccess: 'Acceso del Alumno',
    copyright: 'Copyright {{year}} {{siteName}}. Todos los derechos reservados.',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    taglineSuffix: 'Habla inglés con confianza.',
    developerCredit: 'Diseñado y desarrollado por Suddenly Creative and Technology',
  },
  contact: {
    hero: {
      badge: 'Ponte en Contacto',
      title: 'Hablemos',
      body: '¿Tienes preguntas o quieres ayuda para elegir el curso correcto?\nContáctanos y te orientaremos.',
    },
    ctaCard: {
      title: '¿Listo Para Empezar a Aprender?',
      body: 'Reserva una clase de prueba y conoce nuestro enfoque de enseñanza en la práctica.',
      button: 'Reservar Clase de Prueba',
    },
    phoneText: 'Comparte tu teléfono o WhatsApp en el formulario y te contactaremos por ahí.',
    locationText: 'Clases en línea en todo el mundo y presencial disponible',
    responseTime: 'Respondemos dentro de un día hábil',
    infoEmailTitle: 'Escríbenos',
    infoPhoneTitle: 'Teléfono / WhatsApp',
    infoLocationTitle: 'Ubicación',
    infoResponseTimeTitle: 'Tiempo de Respuesta',
    nameLabel: 'Nombre',
    namePlaceholder: 'Tu nombre',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'tucorreo@email.com',
    phoneLabel: 'Teléfono / WhatsApp',
    phonePlaceholder: 'Tu teléfono o WhatsApp',
    inquiryForLabel: 'Esta consulta es para',
    inquiryOptionMyself: 'Mí mismo/a',
    inquiryOptionAnotherPerson: 'Otra persona',
    inquiryOptionGroup: 'Un grupo de personas',
    inquiryOptionCompany: 'Una empresa / equipo',
    ageLabelSelf: 'Tu edad',
    ageLabelStudent: 'Edad del alumno',
    agePlaceholder: 'Edad',
    groupSizeLabel: 'Tamaño aproximado del grupo',
    groupSizePlaceholder: 'Número de alumnos',
    companyNameLabel: 'Nombre de la empresa',
    companyNamePlaceholder: 'Empresa / organización',
    ageRangeLabel: 'Rango de edad del grupo',
    ageRangePlaceholder: 'Ejemplo: 14-17 o adultos',
    teamSizeLabel: 'Tamaño del equipo',
    teamSizePlaceholder: 'Número de participantes',
    nativeLanguageLabelTeam: 'Idioma nativo principal del equipo',
    nativeLanguageLabelGroup: 'Idioma nativo principal del grupo',
    nativeLanguageLabelDefault: 'Idioma nativo',
    nativeLanguagePlaceholder: 'Español',
    countryLabelCompany: 'País / ubicación de la empresa',
    countryLabelDefault: 'País',
    countryPlaceholder: 'España',
    messageLabel: 'Mensaje',
    messagePlaceholderCompany: 'Cuéntanos sobre los objetivos del equipo, el sector y el horario preferido.',
    messagePlaceholderGroup: 'Cuéntanos sobre el grupo, los objetivos y el horario preferido.',
    messagePlaceholderDefault: '¿Cómo podemos ayudarte?',
    sendButton: 'Enviar Mensaje',
    sending: 'Enviando...',
    errorFallback: 'Ha ocurrido un error. Inténtalo de nuevo.',
    successTitle: '¡Mensaje Enviado!',
    successBody: 'Gracias por contactarnos. Te responderemos en el plazo de un día hábil.',
    consentPrefix: 'Al enviar este formulario, confirmas que has leído y aceptas nuestra',
    consentAnd: 'y',
  },
  bookTrial: {
    durationBadge: '30-45 minutos',
    viaGoogleMeet: 'Vía Google Meet',
    scheduleTitle: 'Agenda tu Clase de Prueba',
    scheduleBodyWithUrl: 'Haz clic en el botón de abajo para ver los horarios disponibles y reservar tu clase de prueba. Las sesiones duran aproximadamente 30-45 minutos, vía Google Meet.',
    scheduleBodyWithoutUrl: 'Nuestro enlace de reservas se está finalizando. Usa el botón de abajo para contactarnos directamente y organizaremos tu clase de prueba de forma personal.',
    openCalendarButton: 'Abrir Calendario de Reservas',
    contactToScheduleButton: 'Contactar para Agendar',
    scheduleNoteWithUrl: 'Serás redirigido/a a nuestra página de reservas para elegir el horario que prefieras.',
    scheduleNoteWithoutUrl: 'Comparte tus días y horarios preferidos, y nuestro equipo te responderá con las mejores opciones disponibles.',
    hero: {
      badge: 'Comienza Ahora',
      title: 'Reserva Tu [hl]Clase de Prueba[/hl]',
      body: 'Comienza con una primera sesión pensada para entender tu nivel, tus objetivos y el mejor camino para tu proceso de aprendizaje.',
    },
    includesSection: {
      badge: 'Beneficios de la Clase de Prueba',
      title: 'Qué Incluye Tu Clase de Prueba',
      body: 'Una introducción completa para que empieces tu camino en el inglés con confianza.',
    },
    nextStepsSection: {
      badge: 'Próximos Pasos',
      title: 'Qué Sucede Después de Tu Clase de Prueba',
    },
    bottomCta: {
      body: '¿Todavía no estás listo para reservar? Haz primero nuestra evaluación de nivel gratuita.',
      button: 'Hacer Evaluación de Nivel Gratuita',
    },
    includesList: [
      { title: 'Evaluación de Necesidades', description: 'Conversamos sobre tus objetivos, intereses y lo que quieres lograr con el inglés.' },
      { title: 'Evaluación de Nivel', description: 'Una conversación amistosa para entender tu nivel actual de inglés.' },
      { title: 'Plan Personalizado', description: 'Recibe un camino de aprendizaje recomendado, adaptado a tus necesidades.' },
      { title: 'Vista Previa del Estilo de Enseñanza', description: 'Conoce nuestro enfoque de enseñanza dinámico y cercano.' },
    ],
    stepsList: [
      { title: 'Recibe Tu Evaluación', description: 'Recibirás comentarios sobre tu nivel actual y áreas de mejora.' },
      { title: 'Recibe Tu Plan Recomendado', description: 'Te sugeriremos el mejor curso y paquete según tus objetivos.' },
      { title: 'Elige Tu Paquete', description: 'Selecciona el paquete de clases que se ajuste a tu horario y presupuesto.' },
      { title: 'Comienza Tu Camino', description: 'Empieza las clases regulares y sigue tu progreso hacia un inglés con confianza.' },
    ],
  },
  auth: {
    login: {
      title: 'Bienvenido/a de Nuevo',
      subtitle: 'Inicia sesión para acceder a tu portal de aprendizaje',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'tucorreo@email.com',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Introduce tu contraseña',
      submit: 'Iniciar Sesión',
      submitting: 'Iniciando sesión...',
      newHere: '¿Primera vez aquí?',
      createAccount: 'Crear una Cuenta',
      termsNotice: 'Al iniciar sesión, aceptas nuestros Términos de Servicio',
      suspendedMessage: 'Tu cuenta está suspendida. Ponte en contacto con soporte para obtener ayuda.',
      toastSuspendedTitle: 'Cuenta suspendida',
      toastWelcomeTitle: '¡Bienvenido/a de nuevo!',
      toastWelcomeDescription: 'Sesión iniciada como {{name}}',
      toastFailedTitle: 'Error al iniciar sesión',
    },
    register: {
      title: 'Crear Cuenta',
      subtitle: 'Únete a nosotros y comienza tu camino con el inglés',
      fullNameLabel: 'Nombre Completo',
      fullNamePlaceholder: 'Tu nombre completo',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'tucorreo@email.com',
      phoneLabel: 'Número de Teléfono',
      phoneOptional: '(opcional)',
      phonePlaceholder: '+34 600 000 000',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      confirmPasswordLabel: 'Confirmar Contraseña',
      confirmPasswordPlaceholder: 'Repite tu contraseña',
      submit: 'Crear Cuenta',
      submitting: 'Creando cuenta...',
      alreadyHaveAccount: '¿Ya tienes una cuenta?',
      signIn: 'Iniciar Sesión',
      termsNotice: 'Al crear una cuenta, aceptas nuestros Términos de Servicio',
      errorPasswordMismatch: 'Las contraseñas no coinciden',
      errorPasswordTooShort: 'La contraseña debe tener al menos 8 caracteres',
      toastCreatedTitle: '¡Cuenta creada!',
      toastCreatedDescription: 'Tu registro está pendiente de aprobación.',
      toastFailedTitle: 'Error en el registro',
    },
  },
  levelTest: {
    hero: {
      badge: 'Evaluación de Nivel',
      title: 'Descubre Tu [hl]Nivel de Inglés[/hl]',
      body: 'Haz una evaluación rápida para entender tu nivel actual y recibir un plan de aprendizaje recomendado según tus resultados.',
    },
    emailStep: {
      badge: 'Último Paso',
      title: 'Ve Tu Resultado y Recomendación',
      body: 'Ingresa tu correo para desbloquear tu evaluación de nivel, guardar tu resultado y recibir el plan recomendado para tus objetivos con el inglés.',
    },
    assessedHeading: 'Qué se evaluará:',
    categoryGrammar: 'Gramática',
    categoryVocabulary: 'Vocabulario',
    categoryReadingComprehension: 'Comprensión de lectura',
    categoryPracticalCommunication: 'Comunicación práctica',
    durationNote: 'Esta prueba tarda aproximadamente entre 5 y 10 minutos en completarse.',
    startButton: 'Comenzar Prueba de Nivel',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'tucorreo@email.com',
    saving: 'Guardando tu resultado...',
    showResult: 'Ver Mi Resultado',
    reviewAnswers: 'Revisar mis respuestas',
    questionCounter: 'Pregunta {{current}} de {{total}}',
    previous: 'Anterior',
    next: 'Siguiente',
    continueButton: 'Continuar',
    scoreLine: 'Puntuación: {{score}} de {{total}}',
    recommendedPlanLabel: 'Plan recomendado:',
    seePlanOptions: 'Ver mis opciones de plan',
    createAccountCta: 'Crear cuenta y empezar',
    bookTrialCta: 'Reservar Clase de Prueba',
    leadErrorFallback: 'No se pudo guardar tu resultado en este momento. Inténtalo de nuevo.',
    categoryBadge: {
      Grammar: 'Gramática',
      Vocabulary: 'Vocabulario',
      Reading: 'Lectura',
    },
    results: {
      beginner: {
        title: 'Estás en un Nivel Principiante / Elemental',
        description: 'Estás construyendo tu base. Un plan de aprendizaje estructurado y con acompañamiento te ayudará a ganar confianza y constancia.',
        plan: 'Plan Inicial / Inglés General',
      },
      intermediate: {
        title: 'Estás en un Nivel Intermedio',
        description: 'Ya tienes una base sólida. Este es el momento perfecto para mejorar la fluidez, la precisión y la confianza en la comunicación real.',
        plan: 'Plan Intermedio',
      },
      upperIntermediate: {
        title: 'Estás en un Nivel Intermedio-Alto',
        description: 'Estás listo/a para perfeccionar tu comunicación, mejorar la precisión y usar el inglés con más confianza en situaciones profesionales y cotidianas.',
        plan: 'Plan Profesional / Progreso Avanzado',
      },
      advanced: {
        title: 'Estás en un Nivel Avanzado',
        description: 'Ya te comunicas con confianza. Ahora el enfoque está en el refinamiento, la precisión, la sofisticación y la fluidez avanzada.',
        plan: 'Plan Avanzado / Intensivo',
      },
    },
  },
  legal: {
    badge: 'Legal',
    privacy: {
      title: 'Política de Privacidad',
      intro: 'Recopilamos únicamente la información necesaria para responder a las consultas, gestionar las cuentas de los alumnos y ofrecer las clases de forma segura y eficaz.',
      collectTitle: 'Información que Recopilamos',
      collectBody: 'Podemos recopilar tu nombre, correo electrónico, número de teléfono, preferencias de curso, mensajes del formulario de contacto, solicitudes de clase de prueba, datos de la cuenta y actividad de aprendizaje enviada a través del portal del alumno.',
      useTitle: 'Cómo Usamos tu Información',
      useBody: 'Usamos tu información para responder consultas, organizar clases de prueba, recomendar cursos, gestionar el acceso de los alumnos, comunicarnos sobre las clases y mejorar la experiencia de aprendizaje. También podemos usar datos agregados del sitio web para entender el rendimiento y la eficacia de marketing.',
      sharingTitle: 'Compartir Datos',
      sharingBody: 'No vendemos tu información personal. Podemos compartir datos limitados con proveedores de servicios de confianza, como plataformas de agendamiento, análisis, pago o alojamiento, solo cuando sea necesario para operar la escuela y prestar nuestros servicios.',
      retentionTitle: 'Retención y Seguridad',
      retentionBody: 'Conservamos la información solo durante el tiempo necesario para fines legítimos de negocio, educativos, legales y de soporte. Utilizamos medidas administrativas y técnicas razonables para proteger los datos almacenados en nuestros sistemas.',
      rightsTitle: 'Tus Derechos',
      rightsBody: 'Puedes solicitar el acceso, la corrección o la eliminación de la información personal que almacenamos sobre ti, sujeto a requisitos legales y operativos. Para hacer una solicitud, contáctanos en',
      updatesTitle: 'Actualizaciones',
      updatesBody: 'Podemos actualizar esta política a medida que evolucionen la escuela, los requisitos legales o las herramientas operativas. El uso continuado del sitio después de una actualización implica la aceptación de la política revisada.',
    },
    terms: {
      title: 'Términos de Servicio',
      intro: 'Estos términos regulan el uso de nuestro sitio web, el proceso de reserva de clases de prueba, los formularios de contacto y el portal del alumno.',
      servicesTitle: 'Servicios',
      servicesBody: 'Frankly Talking English ofrece servicios de enseñanza de inglés, clases de prueba, orientación de nivelación y herramientas de aprendizaje para alumnos. Los formatos de curso, horarios, paquetes y disponibilidad pueden cambiar según la capacidad de los profesores y las necesidades del programa.',
      bookingTitle: 'Reservas y Comunicación',
      bookingBody: 'Las solicitudes de clase de prueba, los envíos de contacto y los registros de alumnos deben contener información precisa. Podemos contactarte por correo electrónico u otros canales autorizados para confirmar disponibilidad, nivelación, agendamiento y actualizaciones operativas.',
      accountsTitle: 'Cuentas de Alumnos',
      accountsBody: 'El acceso al portal es personal y no debe compartirse. Los usuarios son responsables de mantener la confidencialidad de sus credenciales de acceso y de las actividades realizadas a través de su cuenta.',
      paymentsTitle: 'Pagos y Agendamiento',
      paymentsBody: 'Los precios, métodos de pago, condiciones de los paquetes y horarios de clase se confirman durante el proceso de inscripción. Las condiciones de reprogramación, cancelación y reembolso pueden variar según el paquete y se comunicarán antes de que comience el servicio.',
      acceptableUseTitle: 'Uso Aceptable',
      acceptableUseBody: 'Los usuarios no pueden hacer un uso indebido del sitio, interferir con la seguridad de la plataforma, intentar accesos no autorizados ni enviar contenido ilegal, abusivo o engañoso a través de ningún formulario, clase, mensaje o funcionalidad del portal.',
      contactTitle: 'Contacto',
      contactBody: 'Si tienes preguntas sobre estos términos, contáctanos en',
    },
  },
  testimonials: {
    readFullStory: 'Leer historia completa',
    hero: {
      badge: 'Testimonios',
      title: 'Historias reales de alumnos reales',
      body: 'Descubre cómo alumnos de diferentes orígenes ganaron confianza en inglés con el enfoque de enseñanza cercano y personalizado de Cida.',
    },
    ctaSection: {
      title: '¿Listo Para Comenzar Tu Propia [hl]Historia de Éxito[/hl]?',
      body: 'Comienza con una evaluación de nivel gratuita o reserva una clase de prueba y encuentra el camino correcto para tus objetivos.',
      primary: 'Evalúa tu Nivel',
      secondary: 'Reserva una Clase',
    },
  },
  testimonialDetail: {
    backLink: 'Volver a testimonios',
    badge: 'Historia de un Alumno',
    ctaTitle: '¿Listo/a para ganar confianza en inglés?',
    ctaBody: 'Comienza tu camino con clases de inglés personalizadas, diseñadas según tus objetivos.',
    ctaPrimary: 'Comienza tu camino hoy',
    ctaSecondary: 'Reservar Clase de Prueba',
  },
  faq: {
    hero: {
      badge: 'Soporte',
      title: 'Preguntas Frecuentes',
      body: 'Encuentra respuestas a las preguntas más comunes sobre nuestros cursos, horarios y mucho más.',
    },
    ctaSection: {
      title: '¿Todavía tienes preguntas?',
      body: 'Estamos aquí para ayudarte. Contáctanos y responderemos todas tus preguntas.',
      primary: 'Contáctanos',
      secondary: 'Reserva una Clase',
    },
    faqList: [
      { question: '¿Cómo reservo las clases?', answer: 'Comienza con la evaluación de nivel gratuita o una clase de prueba. Después de entender tus objetivos y tu nivel actual, confirmamos contigo directamente el mejor paquete y los horarios disponibles.' },
      { question: '¿Ofrecen clases en línea?', answer: 'Sí. Las clases en línea se imparten en vivo a través de Google Meet. Solo necesitas una conexión a internet estable y una computadora o tablet con cámara y micrófono.' },
      { question: '¿Ofrecen clases presenciales?', answer: 'Sí, según disponibilidad y ubicación. Contáctanos para conversar sobre opciones de clases presenciales en tu zona.' },
      { question: '¿Cómo funciona la evaluación de nivel?', answer: 'Nuestra evaluación de nivel es una prueba en línea rápida que evalúa tu gramática, vocabulario, lectura y comprensión auditiva. Toma entre 5 y 10 minutos y te da una idea práctica de tu nivel actual de inglés, ayudándonos a recomendarte el mejor plan de aprendizaje.' },
      { question: '¿Cómo elijo el paquete correcto?', answer: 'Te recomendamos hacer primero la evaluación de nivel gratuita, que nos ayudará a entender tu nivel actual y sugerirte un paquete adecuado. También puedes reservar una clase de prueba, donde conversamos sobre tus objetivos y te recomendamos la mejor opción.' },
      { question: '¿Puedo reprogramar clases?', answer: 'Sí. Las clases pueden reprogramarse cuando se solicita a través de la agenda de reservas con al menos 24 horas de anticipación. Si el alumno no avisa con 24 horas de anticipación, la clase perdida no tendrá derecho a reembolso ni reposición.' },
      { question: '¿Enseñan a niños y adolescentes?', answer: 'Actualmente enseñamos a alumnos a partir de 16 años. Por el momento, no ofrecemos clases para niños más pequeños.' },
      { question: '¿Ofrecen Inglés para Negocios?', answer: 'Sí. Ofrecemos clases de Inglés para Negocios enfocadas en comunicación profesional real, incluyendo reuniones, presentaciones, correos electrónicos, negociaciones y entrevistas. Estas clases pueden adaptarse a tu industria o profesión específica.' },
      { question: '¿Qué calificaciones tienen los profesores?', answer: 'Nuestra profesora está certificada en CELTA (Cambridge), tiene una maestría en TESOL y actualmente cursa un doctorado enfocado en la enseñanza del inglés en la era de la inteligencia artificial, combinando credenciales reconocidas internacionalmente con investigación de vanguardia en educación lingüística.' },
      { question: '¿Cuánto tiempo se tarda en ver resultados?', answer: 'El progreso varía según tu nivel inicial, tus objetivos y el tiempo que dediques al aprendizaje. La mayoría de los alumnos nota mejoras en las primeras semanas, especialmente en confianza y fluidez.' },
      { question: '¿Qué materiales utilizan?', answer: 'Utilizamos una combinación de materiales de curso de alta calidad, recursos personalizados y contenido del mundo real adaptado a tus intereses y objetivos. Todo el material se entrega a través de Google Classroom.' },
      { question: '¿Cómo pago las clases?', answer: 'Las formas de pago se confirman durante la inscripción según el paquete elegido y la ubicación. Contáctanos y te compartiremos los métodos de pago disponibles y los siguientes pasos.' },
    ],
  },
};

export default es;
